import { render } from "./PhoneIcon.vue?vue&type=template&id=38ea4d14"
import script from "./PhoneIcon.vue?vue&type=script&lang=js"
export * from "./PhoneIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Projects/enwan/enwan-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__